import React, { useEffect } from 'react';
import { useDroneAreasContext } from 'src/contexts/drone-areas.context';
import { actionTypes } from 'src/ducks/drone-areas.duck';
import { getDroneAreasStatus } from 'src/selectors/drone-areas.selector';
import DroneAreasView from './drone-areas-list.view';

const DroneAreas: React.FC = () => {
  const { state, actions } = useDroneAreasContext();
  useEffect(() => {
    actions.listGET();
  }, [actions]);

  return (
    <DroneAreasView
      loading={
        getDroneAreasStatus(state, actionTypes.DRONE_AREAS_FETCH).fetching
      }
      data={state.list}
    />
  );
};

export default DroneAreas;
